var m6CookiesPopin = function () {
    var json = {
        "site": "Meteocity",
        "theme_color_primary": "#429cec",
        "theme_color_secondary": "#329cff",
        "theme_color_tertiary": "#8ec8ff",
        "terms": "En savoir plus sur la charte de confidentialité de meteocity",
        "title": "Gestion des préférences",
        "logo": "http://www.meteocity.com/ressources/site/images/logo.gif",
        "checkbox_status": "Activé",
        "btn_cancel": "Annuler",
        "btn_submit": "Valider mes préférences",
        "link_terms": "http://api-gdpr.m6tech.net/charte-confidentialite-m6-web-meteocity.pdf",
        "tabs": [
            {
                "title": "Cookies Essentiels",
                "description": "Au-delà des cookies essentiels qui permettent de garantir les fonctionnalités importantes du site, nous pouvons être amené à déposer les 4 catégories de cookies suivantes que vous pouvez désactiver. Ces réglages ne seront valables que sur le navigateur que vous utilisez actuellement. Certains cookies sont déposés par nos partenaires et leur permette de suivre votre navigation sur notre service. Vous pouvez paramétrer vos choix soit globalement via votre module, soit partenaire par partenaire en accédant à notre charte de confidentialité."
            },
            {
                "title": "Mesure d'audience",
                "description": "Ces cookies permettent d’établir des statistiques de fréquentation de nos services. Les désactiver nous empêche de suivre et d’améliorer la qualité de nos services."
            },
            {
                "title": "Personnalisation",
                "description": "Ces cookies permettent d’analyser votre navigation et de définir vos centres d’intérêts pour personnaliser nos services et contenus. Les désactiver nous empêche de vous proposer une expérience personnalisée."
            },
            {
                "title": "Publicité personnalisée",
                "description": "Ces cookies permettent d’analyser votre navigation et de définir vos centres d’intérêts pour vous proposer des publicités plus pertinentes. Les désactiver n’a aucun impact sur le volume de publicité que vous recevrez.",
                "advancedSettingsTxt": "Voir les paramètres avancés de la publicité",
                "advancedSettingsTitle": "Paramètres avancés de la publicité",
                "advancedCloserTxt": "Retour"
            },
            {
                "title": "Réseaux sociaux",
                "description": "Ces cookies vous permettent de partager des contenus avec d'autres personnes ou de faire connaître votre consultation ou votre opinion (boutons \"J'aime\"). Les désactiver peut vous empêcher de vous connecter à votre réseau social."
            }
        ]
    };
    var me = this;
    var arrayIAB = [];

    var m6IAB = m6IABManager.getAll();
    var m6IABVendorsAllowed = m6IABManager.getVendorsAllowed();
    var listID = [];
    for (var e = 0, len = m6IAB.length; e < len; e++) {
        var el = m6IAB[e];
        if (el !== undefined) {
            var vendors = el.vendors;
        }
        var iabElementArray = [];
        for (var i = 0, leng = vendors.length; i < leng; i++) {
            var v = vendors[i];
            var checkboxId = false;
            if (listID.indexOf(v.id) === -1) {
                checkboxId = 'vendor-' + v.id
            }
            listID.push(v.id);
            var element = {
                type: 'li',                
                children: [
                    {
                        type: 'span',
                        class: 'iab-vendor-title',                        
                        text: v.name
                    },
                    {
                        type: 'a',
                        class: 'iab-vendor-privacy-link',                        
                        text: '( Private Policy )',
                        attributes: {
                            href: v.policyUrl.indexOf('http') === 0 ? v.policyUrl : 'http://' + v.policyUrl,
                            target: '_blank',
                            rel: 'noopener'
                        }
                    },
                    {
                        type: 'input',
                        class: 'iab-vendor-check',                        
                        attributes: (function () {
                            var o = {
                                type: 'checkbox',
                                id: checkboxId,
                            };

                            if (m6IABVendorsAllowed.includes(v.id)) {
                                o.checked = "checked";
                            }

                            return o;
                        })()
                    },
                    {
                        type: 'label',                        
                        class: (function () {
                            if (m6IABVendorsAllowed.includes(v.id)) {
                                return 'labelCheck,active,check-id-' + v.id
                            } else {
                                return 'labelCheck,check-id-' + v.id
                            }
                        })(),
                        attributes: {
                            for: 'vendor-' + v.id,
                            onclick: 'm6CookiesPopin.checkLabel(' + v.id + ')'
                        }
                    }
                ]
            };
            iabElementArray.push(element)
        }

        var iabElements = [
            {
                type: 'h5',
                class: 'iab-subtitle',
                text: el.name,                
            },
            {
                type: 'p',
                class: 'iab-description',                
                text: el.description
            },
            {
                type: 'ul',
                class: 'list-iab-elements',                
                children: iabElementArray
            }
        ];
        var container = {
            type: 'div',
            class: 'IAB-elements',
            children: iabElements
        };
        arrayIAB.push(container);
    }

    if (window.hasOwnProperty('m6GdprJSONExtra') && typeof m6GdprJSONExtra === 'object') {
        for (var attrname in m6GdprJSONExtra) {
            json[attrname] = m6GdprJSONExtra[attrname];
        }
    }

    // class prefix
    me.prefix = 'm6';

    // set element breakpoints (mobile first !)
    me.mediaQueries = {
        large: '640'
    };

    // create html elements
    me.html = m6CookiesEls.init([{
        class: me.prefix + '_pop-privacy',
        id: '_pop-privacy',
        style: {
            default: 'position:fixed;width:100%;height:100%;top:0;left:0; overflow: scroll; z-index: 9999',
            large: 'position:fixed;height:100%;top:0;left:0;'
        },
        children: [{
            class: me.prefix + '_pop-overlay',
            style: "height:100%;width:100%;background:rgba(0,0,0,0.4);",
            click: function (e) {
                if (!m6Gdpr.hasCookieConsentement()) {
                    window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_GDPR_INFOS, { detail: { choices: '1:1,2:1,3:1,4:1' } }));
                    window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_IAB_INFOS, { detail: { choices: null } }));
                }
                me.close(e);
            }
        }, {
            type: 'form',
            class: me.prefix + '_pop-container',
            style: {
                default: 'margin:auto;position:absolute; left:0; top: 40px;background:#fff;font-family:"Arial", sans-serif;box-shadow:0 0 10px rgba(0,0,0,0.4);',
                large: 'position:absolute;width:600px;top:50%;left:50%;transform:translate(-50%, -50%);'
            },
            children: [{
                type: 'a',
                class: me.prefix + '_pop_close',
                text: '&times;',
                style: {
                    default: "display: block;text-decoration:none;font-size:3em;color:#fff;position:fixed;right:5px;top:4px;line-height:25px;z-index:2; padding: 10px;",
                    large: "top:0px;"
                },
                click: function (e) {
                    if (!m6Gdpr.hasCookieConsentement()) {
                        window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_GDPR_INFOS, { detail: { choices: '1:1,2:1,3:1,4:1' } }));
                        window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_IAB_INFOS, { detail: { choices: null } }));
                    }
                    me.close(e);
                }
            }, {
                class: me.prefix + '_pop-header',
                style: {
                    default: 'position:fixed;' +
                        'background:' + json.theme_color_primary + ';' +
                        'display: flex;' +
                        'left: 0;' +
                        'top: 0;' +
                        'right: 0;' +
                        'padding: 10px;' +
                        'align-items: center;' +
                        'z-index: 100',
                    large: 'position: relative;'
                },
                children: [{
                    class: me.prefix + '_pop-logo-container',
                    style: {
                        default: 'display:none',
                        large: 'width:130px;height:auto;display:block;'
                    },
                    children: [{
                        type: 'img',
                        class: me.prefix + '_pop-logo',
                        attributes: {
                            src: json.logo
                        },
                        style: 'width: 90%;'
                    }]
                }, {
                    class: me.prefix + '_pop-title',
                    text: json.title,
                    style: 'font-size:20px;font-weight:bold;color:#fff;margin-left: 20px;'
                }]
            }, {
                class: me.prefix + '_pop-content',
                style: 'display: flex;width: 100%;',
                children: [{
                    type: 'ul',
                    class: me.prefix + '_pop-nav',
                    style: {
                        default: 'display:none',
                        large: 'display:block;min-width:150px;background:' + json.theme_color_tertiary + ';margin: 0;padding: 0;list-style: none;'
                    },
                    children: [
                        {
                            type: 'li',
                            class: [me.prefix + '_pop-nav-item', me.prefix + '_pop-nav-item_active'],
                            text: json.tabs[0].title,
                            style: 'background: ' + json.theme_color_secondary + '; margin: 0;',
                            attributes: {
                                dataTab: 1
                            },
                            click: function (e) {
                                me.changeTab(e, this);
                            }
                        }, {
                            type: 'li',
                            class: me.prefix + '_pop-nav-item',
                            text: json.tabs[1].title,
                            style: 'padding: 20px 10px;margin:0;border-bottom: 1px solid rgba(0,0,0,0.4);color:#fff;cursor:pointer',
                            attributes: {
                                dataTab: 2
                            },
                            click: function (e) {
                                me.changeTab(e, this);
                            }
                        }, {
                            type: 'li',
                            class: me.prefix + '_pop-nav-item',
                            text: json.tabs[2].title,
                            attributes: {
                                dataTab: 3
                            },
                            click: function (e) {
                                me.changeTab(e, this);
                            }
                        }, {
                            type: 'li',
                            class: me.prefix + '_pop-nav-item',
                            text: json.tabs[3].title,
                            attributes: {
                                dataTab: 4
                            },
                            click: function (e) {
                                me.changeTab(e, this);
                            }
                        },
                        {
                            type: 'li',
                            class: me.prefix + '_pop-nav-item',
                            text: json.tabs[4].title,
                            attributes: {
                                dataTab: 5
                            },
                            click: function (e) {
                                me.changeTab(e, this);
                            }
                        }]
                }, {
                    class: me.prefix + '_pop-tabs',
                    style: 'padding: 20px; position: relative',
                    children: [{
                        id: 'tabs-1',
                        class: [me.prefix + '_pop-tab', me.prefix + '_pop-tab_active'],
                        style: 'display:block',
                        children: [{
                            type: 'h4',
                            text: json.tabs[0].title,
                            class: me.prefix + '_pop-tab-h4',
                            style: 'font-family: "Arial", sans-serif;'
                        }, {
                            type: 'input',
                            attributes: {
                                type: "checkbox",
                                checked: "checked",
                                disabled: "true",
                                id: me.prefix + '_checkbox_0'
                            }
                        }, {
                            type: 'label',
                            text: json.checkbox_status,
                            class: me.prefix + '_pop-tab-label',
                            style: 'font-family: "Arial", sans-serif;',
                            attributes: {
                                for: me.prefix + '_checkbox_0'
                            }
                        }, {
                            type: 'p',
                            text: json.tabs[0].description
                        }]
                    }, {
                        id: 'tabs-2',
                        class: me.prefix + '_pop-tab',
                        style: {
                            default: 'display:block;',
                            large: 'display:none;'
                        },
                        children: [{
                            type: 'h4',
                            class: me.prefix + '_pop-tab-h4',
                            style: 'font-family: "Arial", sans-serif;',
                            text: json.tabs[1].title,
                        }, {
                            type: 'input',
                            attributes: (function () {
                                var o = {
                                    type: "checkbox",
                                    id: me.prefix + '_checkbox_1'
                                };

                                if(m6Gdpr.hasCookieConsentement() === null) {
                                    if(typeof m6GdprJSONExtra !== 'undefined' &&
                                        typeof m6GdprJSONExtra['purposes_default_values'] !== 'undefined' &&
                                        typeof m6GdprJSONExtra['purposes_default_values'][0] === 'boolean') {
                                        if(m6GdprJSONExtra['purposes_default_values'][0]) o.checked =  'checked';
                                    } else o.checked = 'checked';
                                } else if (parseInt(m6Gdpr.getCookieConsentementChoices(1)) === 1) o.checked = "checked";

                                return o;
                            })()
                        }, {
                            type: 'label',
                            text: json.checkbox_status,
                            class: me.prefix + '_pop-tab-label',
                            style: 'font-family: "Arial", sans-serif;',
                            attributes: {
                                for: me.prefix + '_checkbox_1'
                            }
                        }, {
                            type: 'p',
                            text: json.tabs[1].description,
                            class: me.prefix + '_pop-tab-p',
                            style: 'font-family: "Arial", sans-serif;'
                        }]
                    }, {
                        id: 'tabs-3',
                        class: me.prefix + '_pop-tab',
                        children: [{
                            type: 'h4',
                            text: json.tabs[2].title,
                            class: me.prefix + '_pop-tab-h4',
                            style: 'font-family: "Arial", sans-serif;'
                        }, {
                            type: 'input',
                            attributes: (function () {
                                var o = {
                                    type: "checkbox",
                                    id: me.prefix + '_checkbox_2'
                                };

                                if(m6Gdpr.hasCookieConsentement() === null) {
                                    if(typeof m6GdprJSONExtra !== 'undefined' &&
                                        typeof m6GdprJSONExtra['purposes_default_values'] !== 'undefined' &&
                                        typeof m6GdprJSONExtra['purposes_default_values'][1] === 'boolean') {
                                        if(m6GdprJSONExtra['purposes_default_values'][1]) o.checked = 'checked';
                                    } else o.checked = 'checked';
                                } else if (parseInt(m6Gdpr.getCookieConsentementChoices(2)) === 1) o.checked = "checked";

                                return o;
                            })()
                        }, {
                            type: 'label',
                            text: json.checkbox_status,
                            class: me.prefix + '_pop-tab-label',
                            style: 'font-family: "Arial", sans-serif;',
                            attributes: {
                                for: me.prefix + '_checkbox_2'
                            }
                        }, {
                            type: 'p',
                            text: json.tabs[2].description,
                            class: me.prefix + '_pop-tab-p',
                            style: 'font-family: "Arial", sans-serif;'
                        }]
                    }, {
                        id: 'tabs-4',
                        class: me.prefix + '_pop-tab',
                        children: [{
                            type: 'h4',
                            text: json.tabs[3].title, class: me.prefix + '_pop-tab-h4',
                            style: 'font-family: "Arial", sans-serif;'
                        }, {
                            type: 'input',
                            attributes: (function () {
                                var o = {
                                    type: "checkbox",
                                    id: me.prefix + '_checkbox_3'
                                };

                                if(m6Gdpr.hasCookieConsentement() === null) {
                                    if(typeof m6GdprJSONExtra !== 'undefined' &&
                                        typeof m6GdprJSONExtra['purposes_default_values'] !== 'undefined' &&
                                        typeof m6GdprJSONExtra['purposes_default_values'][2] === 'boolean') {
                                        if(m6GdprJSONExtra['purposes_default_values'][2]) o.checked = 'checked';
                                    } else o.checked = 'checked';
                                } else if (parseInt(m6Gdpr.getCookieConsentementChoices(3)) === 1) o.checked = "checked";

                                return o;
                            })()
                        }, {
                            type: 'label',
                            text: json.checkbox_status,
                            class: me.prefix + '_pop-tab-label',
                            style: 'font-family: "Arial", sans-serif;',
                            attributes: {
                                for: me.prefix + '_checkbox_3'
                            }
                        }, {
                            type: 'p',
                            text: json.tabs[3].description,
                            class: me.prefix + '_pop-tab-p',
                            style: 'font-family: "Arial", sans-serif;'
                        },
                        {
                            type: 'span',
                            class: 'advancedOpener',
                            style: 'color:#000; font-size: 12px; text-decoration: underline; cursor: pointer; font-family: "Arial", sans-serif;',
                            text: (m6IABManager.isVendorListIsDefined() ? json.tabs[3].advancedSettingsTxt : ''),
                            attributes: {
                                onclick: 'm6CookiesPopin.toggleOpenerIab()'
                            }
                        },
                        {
                            type: 'div',
                            class: 'iab-container',
                            style: 'position: absolute; display:none; height: calc(100% - 40px); width: calc(100% - 40px);overflow:scroll; top:0;left:0;background:#ffffff; padding:20px; box-sizing: content-box;',
                            children: [{
                                type: 'span',
                                class: 'advancedTitle',
                                style: 'color: #000; font-size: 18px; font-weight: bold; font-family: "Arial", sans-serif;',
                                text: json.tabs[3].advancedSettingsTitle
                            },
                            {
                                type: 'span',
                                class: 'advancedCloser',
                                style: 'margin-left:30px; color:#000; font-size: 12px; cursor: pointer; font-family: "Arial", sans-serif;',
                                text: json.tabs[3].advancedCloserTxt,
                                attributes: {
                                    onclick: 'm6CookiesPopin.toggleOpenerIab()'
                                }
                            },
                            {
                                type: 'div',
                                class: 'iabContainer',
                                children: arrayIAB
                            }
                            ]
                        }]
                    },
                    {
                        id: 'tabs-5',
                        class: me.prefix + '_pop-tab',
                        children: [
                            {
                                type: 'h4',
                                text: json.tabs[4].title,
                                class: me.prefix + '_pop-tab-h4',
                                style: 'font-family: "Arial", sans-serif;',
                            },
                            {
                                type: 'input',
                                attributes: (function () {
                                    var o = {
                                        type: "checkbox",
                                        id: me.prefix + '_checkbox_4'
                                    };

                                    if(m6Gdpr.hasCookieConsentement() === null) {
                                        if(typeof m6GdprJSONExtra !== 'undefined' &&
                                            typeof m6GdprJSONExtra['purposes_default_values'] !== 'undefined' &&
                                            typeof m6GdprJSONExtra['purposes_default_values'][3] === 'boolean') {
                                            if(m6GdprJSONExtra['purposes_default_values'][3]) o.checked = 'checked';
                                        } else o.checked = 'checked';
                                    } else if (parseInt(m6Gdpr.getCookieConsentementChoices(4)) === 1) o.checked = "checked";

                                    return o;
                                })()
                            },
                            {
                                type: 'label',
                                text: json.checkbox_status,
                                class: me.prefix + '_pop-tab-label',
                                style: 'font-family: "Arial", sans-serif;',
                                attributes: {
                                    for: me.prefix + '_checkbox_4'
                                }
                            },
                            {
                                type: 'p',
                                text: json.tabs[4].description,
                                class: me.prefix + '_pop-tab-p',
                                style: 'font-family: "Arial", sans-serif;',
                            }
                        ]
                    }]
                }]
            }, {
                class: me.prefix + '_pop-btn-container',
                style: {
                    default: 'text-align:center;padding:15px 15px 40px;background:' + json.theme_color_primary + ';',
                    large: 'text-align:right;padding-bottom:15px;'
                },
                children: [{
                    type: 'a',
                    class: me.prefix + '_pop-terms',
                    href: json.link_terms,
                    attributes: {
                        target: '_blank',
                        rel: 'nofollow'
                    },
                    text: json.terms,
                    style: {
                        default: 'color:#fff;font-size:12px;opacity:0.9;text-align:center;display: block;margin: 0 auto 30px; font-family: "Arial", sans-serif;',
                        large: 'margin-right:20px;display:inline-block; margin-bottom:0px; max-width: 300px;text-align:left; vertical-align:middle; font-family: "Arial", sans-serif;'
                    }
                }, {
                    type: 'a',
                    class: me.prefix + '_pop-btn-cancel',
                    text: json.btn_cancel,
                    style: 'color: #fff;font-weight: bold;text-decoration: underline;margin-right: 20px; font-family: "Arial", sans-serif;',
                    click: function (e) {
                        if (!m6Gdpr.hasCookieConsentement()) {
                            window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_GDPR_INFOS, { detail: { choices: '1:1,2:1,3:1,4:1' } }));
                            window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_IAB_INFOS, { detail: { choices: null } }));
                        }
                        me.close(e);
                    }
                }, {
                    type: 'button',
                    class: me.prefix + '_pop-btn-submit',
                    text: json.btn_submit,
                    style: 'cursor:pointer;background:#36db75;color:#fff;border:none;padding:10px;border-radius:3px; font-family: "Arial", sans-serif;',
                    click: function (e) {
                        var analyticsCookies = document.getElementById(me.prefix + '_checkbox_1').checked ? 1 : 0;
                        var featureCookies = document.getElementById(me.prefix + '_checkbox_2').checked ? 1 : 0;
                        var adsCookies = document.getElementById(me.prefix + '_checkbox_3').checked ? 1 : 0;
                        var socialCookies = document.getElementById(me.prefix + '_checkbox_4').checked ? 1 : 0;
                        var choices = '1:' + analyticsCookies + ',2:' + featureCookies + ',3:' + adsCookies + ',4:' + socialCookies;

                        var iabVendors = document.getElementsByClassName('iab-vendor-check');
                        var iabVendorsChoices = [];
                        for (var a = 0, lengh = iabVendors.length; a < lengh; a++) {
                            if (iabVendors[a].id !== 'false') {
                                var vendorID = iabVendors[a].id.replace('vendor-', '');
                                var vendorChecked = iabVendors[a].checked;
                                var obj = { 'id': vendorID, 'isEnabled': vendorChecked };
                                iabVendorsChoices.push(obj);
                            }
                        }
                        window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_GDPR_INFOS, { detail: { choices: choices } }));
                        window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_IAB_INFOS, { detail: { choices: iabVendorsChoices } }));

                        me.close(e);
                    }
                }]
            }]
        }]
    }]);

    // create elements style
    me.styleheet = new m6CookiesStyles(me);

    var _tagStyle = document.createElement('style');
    _tagStyle.type = 'text/css';
    var style = '.active {background: #5d9afc;}';
    style += '.dblock-container {display: block}';
    style += '.iab-vendor-title {font-size:12px; color:#000; font-family: "Arial", sans-serif;}';
    style += '.iab-vendor-privacy-link {font-size:12px; text-decoration:underline; color:#000; font-family: "Arial", sans-serif;}';
    style += '.iab-vendor-check {position:absolute; z-index: -1;}';
    style += '.labelCheck {height:10px; width:10px; display:inline-block; border-radius: 3px; border: 1px solid #969696; position: absolute; right:20px; font-family: "Arial", sans-serif;}';
    style += '.iab-subtitle {font-family: "Arial", sans-serif;}';
    style += '.iab-description {font-size:12px; font-family: "Arial", sans-serif;}';
    style += '.list-iab-elements {margin:0; padding:0; list-style:none; font-family: "Arial", sans-serif;}';
    _tagStyle.appendChild(document.createTextNode(style));
    var _popin = document.getElementById('_pop-privacy');
    _popin.insertBefore(_tagStyle, _popin.nextSibling)

    // close cookie popin function
    me.close = function (e) {
        e.preventDefault();
        document.body.removeChild(me.html[0].html);
    };

    me.changeTab = function (e, li) {
        e.preventDefault();
        var numberId = li.html.getAttribute('data-tab');
        var tab = document.getElementById('tabs-' + numberId);
        var tabs = Array.from(document.getElementsByClassName(me.prefix + '_pop-tab'));
        var tabsNav = Array.from(document.getElementsByClassName(me.prefix + '_pop-nav-item'));
        tabs.forEach(function (tab) {
            tab.classList.remove(me.prefix + '_pop-tab_active');
        });
        tabsNav.forEach(function (tab) {
            tab.classList.remove(me.prefix + '_pop-nav-item_active');
        });
        tab.classList.add(me.prefix + '_pop-tab_active');
        li.html.classList.add(me.prefix + '_pop-nav-item_active');
    };

    return me;
};

m6CookiesPopin.checkLabel = function (id) {
    var x = document.getElementsByClassName('check-id-' + id);
    for (var i = 0, len = x.length; i < len; i++) {
        x[i].classList.toggle("active");
    }
};

m6CookiesPopin.toggleOpenerIab = function (e) {
    document.getElementsByClassName('iab-container')[0].classList.toggle('dblock-container')
};

window.m6CookiesPopin = m6CookiesPopin;
